// tienda/TierCard.jsx

import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Clock } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

export function TierCard({ icon, tag, tagColor, title, price, cutoff, delivery, perks, featured }) {
  return (
    <motion.div
      {...fadeUp}
      className="relative overflow-hidden rounded-2xl border bg-white p-6 shadow-sm"
      style={{
        borderColor: featured ? tagColor : brand.line,
        boxShadow: featured ? `0 24px 60px ${tagColor}20` : undefined,
      }}
    >
      {featured && (
        <div className="absolute inset-x-0 top-0 h-1.5" style={{ background: `linear-gradient(90deg, ${brand.primary}, ${tagColor})` }} />
      )}

      <div className="mb-5 flex items-start justify-between gap-4">
        <div className="grid size-12 place-items-center rounded-2xl" style={{ background: `${tagColor}16`, color: tagColor }}>
          {icon}
        </div>
        <span className="rounded-full px-3 py-1 text-[11px] font-black text-white" style={{ background: tagColor }}>
          {tag}
        </span>
      </div>

      <h3 className="text-xl font-black" style={{ color: brand.ink }}>{title}</h3>

      <div className="mt-4 flex items-end gap-1.5">
        <span className="text-4xl font-black" style={{ color: brand.primary }}>{price}</span>
        <span className="pb-1 text-xs font-semibold" style={{ color: brand.muted }}>por entrega</span>
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-2 text-xs">
        <span className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 font-bold" style={{ background: `${tagColor}12`, color: tagColor }}>
          <Clock className="size-3.5" />
          {cutoff}
        </span>
        <span style={{ color: brand.muted }}>{delivery}</span>
      </div>

      <ul className="mt-6 space-y-3">
        {perks.map(perk => (
          <li key={perk} className="flex items-start gap-2 text-sm" style={{ color: brand.muted }}>
            <CheckCircle2 className="mt-0.5 size-4 shrink-0" style={{ color: tagColor }} />
            {perk}
          </li>
        ))}
      </ul>

      <Link
        to="/register"
        className="mt-6 block rounded-xl py-3 text-center text-sm font-black text-white transition-transform hover:-translate-y-0.5"
        style={{ background: featured ? brand.primary : tagColor }}
      >
        Empezar ahora
      </Link>
    </motion.div>
  );
}
